export default "__VITE_ASSET__C39KksO___"